import { Card, CardContent, CardHeader, CardTitle, DataTableSkeleton } from '@data-delivery/d3s';

export function AssignmentSummarySkeleton() {
  return (
    <Card>
      <CardHeader className='pb-3'>
        <CardTitle className='text-base'>Assignment</CardTitle>
      </CardHeader>
      <CardContent>
        <div className='flex flex-wrap gap-6'>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className='flex min-w-[140px] max-w-xs flex-col'>
              <div className='h-2 w-20 animate-pulse rounded bg-muted' />
              <div className='mt-2 h-4 w-32 animate-pulse rounded bg-muted' />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export function AssignmentUsersSkeleton() {
  return (
    <Card className='flex-1'>
      <CardHeader className='pb-3'>
        <CardTitle className='text-sm font-medium'>Assigned Users</CardTitle>
      </CardHeader>
      <CardContent className='flex flex-col gap-2'>
        <DataTableSkeleton
          withPagination={false}
          rowCount={6}
          columnCount={2}
          searchableColumnCount={0}
          filterableColumnCount={0}
          showViewOptions={false}
          cellWidths={['12rem', '10rem']}
          shrinkZero
        />
      </CardContent>
    </Card>
  );
}

export default { AssignmentSummarySkeleton, AssignmentUsersSkeleton };
